/**
 * Created by bob.gear on 16/03/2015.
 */
var EICDataStream3ProjectDisplay = angular.module("EICDataStream3.projectDisplay", ["EICDataStream3.resources", "EICDataStream3.logging"])
  .config(function () {
  })
  .filter('highlightKeywords', ['$sce', 'keywordsService', '$sanitize', function ($sce, keywordsService, $sanitize) {
    return function (text) {
      // if there is no text or if there are no keywords, just return whatever 
      // text value was originally supplied.
      if (!text || !keywordsService.keywords) return text;

      // Sanitize the input text because it might have unsafe content
      text = $sanitize(text);

      // Highlight each keyword and set it up as trusted text because it has
      // html embedded in it.
      text = text.replace(keywordsService.regex, keywordsService.replacer);
      return $sce.trustAsHtml(text);
    }
  }]);



EICDataStream3ProjectDisplay.controller('ProjectController', ['ENUMS', '$scope', '$state', '$stateParams', '$location', 'projectDataService', 'projectNavigationService', '$document', '$window', 'trackingStatusService', 'feedbackService', 'dialogService', 'keywordsService', 'reportRequestService', 'FEATURE_SWITCHES',
  function (ENUMS, $scope, $state, $stateParams, $location, projectDataService, projectNavigationService, $document, $window, trackingStatusService, feedbackService, dialogService, keywordsService, reportRequestService, FEATURE_SWITCHES) {

    $scope.componentName = "ProjectController";
    $scope.MEMBER_FEEDBACK = FEATURE_SWITCHES.MEMBER_FEEDBACK;
    $scope.NEW_REPORT_REQUEST = FEATURE_SWITCHES.NEW_REPORT_REQUEST;
    $scope.keywordsService = keywordsService;

    $scope.$emit("DETAIL_PAGE_ACTIVATED", true);

    $scope.projectNameShadowStyle = "";
    //$scope.projectNameShadow = function(isInview){
    //  if(isInview){
    //    $scope.projectNameShadowStyle =""
    //  }
    //  else{
    //    $scope.projectNameShadowStyle = {"box-shadow": "0px 10px 5px -2px #888888", "z-index": 100};
    //  }
    //};

    $scope.onScrollFirst = function () {
      $scope.$broadcast("PROJECT_SCROLLED");
    };

    $scope.onScrollToTop = function () {
      $scope.projectNameShadowStyle = '';
    };

    $scope.onScroll = function () {
      $scope.projectNameShadowStyle = { "box-shadow": "0px 10px 5px -2px #888888" }; //, "z-index": 100
    };

    // $scope.searchService = searchService;
    $scope.projectDataService = projectDataService;



    ////////////////////////////////////////////////////////////////////////////
    // Related Project Navigation
    ////////////////////////////////////////////////////////////////////////////
    $scope.gotoRelatedProject = function (relatedProject) {
      var projectID = relatedProject.relatedProjectProjectID;
      var projectName = relatedProject.relatedProjectProjectName.urlEncode();

      // this needs to go to the correct route, depending on search or favourite list
      $state.go("search.project", { projectID: projectID, projectName: projectName });
    };


    ////////////////////////////////////////////////////////////////////////////
    // Previous/Next Project Navigation
    ////////////////////////////////////////////////////////////////////////////
    $scope.$watch("projectDataService.project.projectID", function () {
      if (!projectDataService.project || !projectDataService.project.projectID) return;

      initialisePrevAndNextProjectNames();
    });


    $scope.gotoPreviousProject = function (projectRoute) {
      var currentProjectIndex = getPreviousProjectIndex();
      var projectID = projectDataService.projectNames[currentProjectIndex].projectID;
      var projectName = projectDataService.projectNames[currentProjectIndex].name.urlEncode();

      // this needs to go to the correct route, depending on search or favourite list
      $state.go(projectRoute, { projectID: projectID, projectName: projectName });
    };

    $scope.gotoNextProject = function (projectRoute) {
      var currentProjectIndex = getNextProjectIndex();
      var projectID = projectDataService.projectNames[currentProjectIndex].projectID;
      var projectName = projectDataService.projectNames[currentProjectIndex].name.urlEncode();

      // this needs to go to the correct route, depending on search or favourite list
      $state.go(projectRoute, { projectID: projectID, projectName: projectName });
    };


    function getCurrentProjectIndex() {
      var currentProjectID = projectDataService.project.projectID;

      for (var i = 0; i < projectDataService.projectNames.length; i++) {
        if (projectDataService.projectNames[i].projectID == currentProjectID) {
          return i;
        }
      }
    };


    // skip forward to the next project to display
    // The trivial case is a simple increment
    //   newIndex++;
    // However, we need to skip over projects that  do not appear in the
    // summary because they do not match the Tracking Status selections
    function getNextProjectIndex() {
      var newIndex = getCurrentProjectIndex();
      var nextTrackingStatusID;
      do {
        newIndex++;

        // terminate if at the end of the array
        if (isNaN(newIndex)) newIndex = -1;
        if (newIndex == projectDataService.projectNames.length) break;

        nextTrackingStatusID = projectDataService.projectNames[newIndex].trackingStatusID
      }
      while (trackingStatusService.selectedValues.indexOf(nextTrackingStatusID) == -1)

      return newIndex;
    }


    // skip back to the next project to display
    // The trivial case is a simple decrement
    //   newIndex--;
    // However, we need to skip over projects that  do not appear in the
    // summary because they do not match the Tracking Status selections
    function getPreviousProjectIndex() {
      var newIndex = getCurrentProjectIndex();
      var previousTrackingStatusID;
      do {
        newIndex--;

        // terminate if at the beginning of the array
        if (isNaN(newIndex)) newIndex = -1;
        if (newIndex < 0) break;

        previousTrackingStatusID = projectDataService.projectNames[newIndex].trackingStatusID
      }
      while (trackingStatusService.selectedValues.indexOf(previousTrackingStatusID) == -1)
      ////////////////////////////////////////////////////////////////////

      return newIndex;
    }


    function initialisePrevAndNextProjectNames() {
      // instantiate previous and next names and indices
      // if getting the next/prev index comes back undefined, set it to
      // a default value which will suppress the name display
      $scope.nextProjectID = 0;
      $scope.previousProjectID = 0;
      $scope.nextProjectName = "";
      $scope.previousProjectName = ""

      var prevIndex = getPreviousProjectIndex(); // || -1;
      var nextIndex = getNextProjectIndex(); // || 0;

      if (projectDataService.projectNames[prevIndex] && prevIndex >= 0) {
        $scope.previousProjectID = projectDataService.projectNames[prevIndex].projectID;
        $scope.previousProjectName = projectDataService.projectNames[prevIndex].name;
      }
      if (nextIndex < projectDataService.projectNames.length) {
        $scope.nextProjectID = projectDataService.projectNames[nextIndex].projectID;
        $scope.nextProjectName = projectDataService.projectNames[nextIndex].name;
      }
    }


    function previousNextProjectCursorHandler(event) {
      $scope.$apply(function () {
        // Process required keyCodes
        if (event.keyCode == 39) $scope.gotoNextProject(projectDataService.projectRoute);
        if (event.keyCode == 37) $scope.gotoPreviousProject(projectDataService.projectRoute);
      });
    }
    // Navigate to Project
    $scope.openProject = function (project) {
      // $state.go("search.project", { projectID: project.projectID, ProjectName: project.name.urlEncode() });
      projectNavigationService.gotoProject(project.projectID, project.name, false);
    };


    /////////   /Previous/Next Contract Navigation   ///////////////////////////

    // Navigate to  Contract
    $scope.openContract = function (contract) {
      var contractDescription = formatContractDescription(contract, projectDataService.project.projectName)
      $state.go("search.contract", { contractID: contract.contractID, contractDescription: contractDescription });
    };

    var formatContractDescription = function (contract, projectName) {
      let shortContractType = contract.shortContractType || "";
      let contractorName = "";

      if (!contract.involvedCompanies.length) {
        contractorName = "";
      }
      else {
        contractorName = contract.involvedCompanies[0].companyName;
      }

      projectName = projectName || "";
      if (projectName.length > 50) projectName = projectName.substring(0, 50)

      contractorName = contractorName || "";
      if (contractorName.length > 50) contractorName = contractorName.substring(0, 50)

      return (shortContractType + "-" + contractorName + "-" + projectName).urlEncode();
    };
    //----------------------

    $scope.openSelectedProjectWatchDialog = function () {
      dialogService.openSelectedProjectWatchDialog(ENUMS.PROJECT_WATCH_CREATE_REASONS.INDIVIDUAL_PROJECT);
    };

    $scope.openSingleProjectPdfReporthDialog = function () {
      reportRequestService.openReportRequestDialog_singledProject(projectDataService.project);
    };

    $scope.print = function () {
      $window.print();
    };

    /**************************************************************************
     * Action Menu
     */
    $scope.share = function () {
      return "mailto:?subject=Information from EICDataStream&body=I thought you might be interested in this project from EICDataStream:%0D%0A%0D%0A{{currentPath}}%0D%0A%0D%0A".replace("{{currentPath}}", $location.absUrl());
    };
    $scope.projectFeedback = function () {
      feedbackService.projectFeedback(projectDataService.project);
    }

    $scope.actionMenu = {
      items: [
        {
          text: "Share...",
          actionType: "href",
          action: $scope.share,
          visible: function () { return true; },
          disabled: function () { return false }
        },
        {
          text: "Watch this project...",
          actionType: "function",
          action: $scope.openSelectedProjectWatchDialog,
          visible: function () { return true; },
          disabled: function () { return false }
        },
        {
          text: "PDF report...",
          actionType: "function",
          action: $scope.openSingleProjectPdfReporthDialog,
          visible: function () {
            return !$scope.NEW_REPORT_REQUEST.SUSPENDED;   
          },
          disabled: function () { return false }
        },
        {
          text: "PDF Report Service Suspended",
          actionType: "function",
          action: function () { },
          visible: function () {
            return $scope.NEW_REPORT_REQUEST.SUSPENDED;
          },
          disabled: function () { return true }
        },
        {
          text: "Print...",
          actionType: "function",
          action: $scope.print,
          visible: function () { return true; },
          disabled: function () { return false }
        },
        {
          text: "Ask/tell us about this project...",
          actionType: "function",
          action: $scope.projectFeedback,
          visible: function () { return true && $scope.MEMBER_FEEDBACK.EnableProjectFeedback; },
          disabled: function () { return false }
        }
      ]
    };


    $scope.areAnyWindTurbinesOffshore = function () {
      if (projectDataService.project.windTurbines) {
        var offshore = false;
        for (let i = 0; i < projectDataService.project.windTurbines.length; i++) {
          offshore = offshore || projectDataService.project.windTurbines[i].isOffshore;
        }

        return offshore;
      }
    };
    $scope.areAllWaveDevicesOffshore = function () {
      if (projectDataService.project.waveDevices) {
        var offshore = false;
        for (let i = 0; i < projectDataService.project.waveDevices.length; i++) {
          offshore = offshore || projectDataService.project.waveDevices[i].isOffshore;
        }

        return offshore;
      }
    };

    $scope.allowRevertToSummary = false;

    $scope.allButtonStyle = 'btn btn-xs btn-default active';
    $scope.noneButtonStyle = 'btn btn-xs btn-default';
    $scope.optionalComponents = {};
    $scope.optionalComponentsExist = false;
    $scope.noPrintIfNoEquipment = "";

    $scope.selectAllOptionalComponents = function () {
      setAllOptionalComponents(true);

      $scope.allButtonStyle = 'btn btn-xs btn-default active';
      $scope.noneButtonStyle = 'btn btn-xs btn-default';
    };
    $scope.unselectAllOptionalComponents = function () {
      setAllOptionalComponents(false);

      $scope.allButtonStyle = 'btn btn-xs btn-default';
      $scope.noneButtonStyle = 'btn btn-xs btn-default active';
    };

    var setAllOptionalComponents = function (value) {
      for (var name in $scope.optionalComponents) {
        if ($scope.optionalComponents.hasOwnProperty(name)) {
          $scope.optionalComponents[name] = value;
        }
      }
    };

    var verifyAllOptionalComponents = function (value) {
      for (var name in $scope.optionalComponents) {
        if ($scope.optionalComponents.hasOwnProperty(name)) {
          // if we find a value that doesn't match, then the value is
          // automatically false an we can bail
          if ($scope.optionalComponents[name] != value) return false;;
        }
      }
      // otherwise they  must have all matched
      return true;
    };

    $scope.optionalComponentTemplateName = function (templateName) {
      // determine the screen width
      // if lest than 630 px, switch to mobile view
      return (window.innerWidth < 630)
        ? mobileTemplateName(templateName)
        : templateName;
    }

    var mobileTemplateName = function (templateName) {
      let t = templateName.split('.');
      t[0] = t[0] + '_mobile';

      return t.join('.');
    }

    $scope.$watch("optionalComponents", function () {
      if (verifyAllOptionalComponents(false)) {
        $scope.allButtonStyle = 'btn btn-xs btn-default';
        $scope.noneButtonStyle = 'btn btn-xs btn-default active';
        $scope.noPrintIfNoEquipment = "no-print";
      }
      else if (verifyAllOptionalComponents(true)) {
        $scope.allButtonStyle = 'btn btn-xs btn-default active';
        $scope.noneButtonStyle = 'btn btn-xs btn-default';
        $scope.noPrintIfNoEquipment = "";
      }
      else {
        $scope.allButtonStyle = 'btn btn-xs btn-default';
        $scope.noneButtonStyle = 'btn btn-xs btn-default';
        $scope.noPrintIfNoEquipment = "";
      }

    }, true);

    // set up logging parameters
    $scope.data = {
      logData: {
        projectID: $stateParams.projectID
      }
    };

    $scope.$on('$viewContentLoaded', function projectController_$viewContentLoaded() {
      var name;

      // Controller startup actions
      $document.bind("keydown", previousNextProjectCursorHandler);
      $scope.allowRevertToSummary = projectDataService.allowRevertToSummary;

      var p = projectDataService.getProject($stateParams.projectID)
        .$promise
        .then(function () {
          // set up  optional component selector here...
          for (let i = 0; i < projectDataService.project.optionalComponents.length; i++) {
            name = projectDataService.project.optionalComponents[i].title;
            $scope.optionalComponents[name] = true;
            $scope.optionalComponentsExist = true;
          }
        },
          function (e, f) {
            var i = 0;
          });

      projectDataService.isProject = true;

    });


    $scope.$on('$destroy', function projectController_$destroy() {
      // close down the controller/ release resources etc.
      $document.unbind("keydown", previousNextProjectCursorHandler);
      projectDataService.project = null;
    });

  }]);


EICDataStream3ProjectDisplay.directive('eicProjectNoteController',
  function () {
    return {
      scope: {
        listItems: '=',                   // list of types with selected fields
        selectedValues: '='
      },
      replace: false,

      link: function (scope, iElement, attrs) {
      },

      // templateUrl: "/app-ds3/search/projectNotes.tmpl.html",
      templateUrl: function () {
        return (window.innerWidth < 600)
          ? "/app-ds3/search/projectNotes_mobile.tmpl.html"
          : "/app-ds3/search/projectNotes.tmpl.html"
      },
      controller: ['$scope', '$timeout', 'dialogs', 'projectDataService',
        function ($scope, $timeout, dialogs, projectDataService) {
          $scope.componentName = "eicNoteTypeSelector";

          $scope.projectDataService = projectDataService;



          //-- Project Notes -------------------------------------------------
          var onScroll = function () {
            // fetch all project notes and fully update the existing, incomplete set of notes
            $scope.ProjectNotes = projectDataService.getAllProjectNotes();
          };
          $scope.$on("PROJECT_SCROLLED", onScroll);

          $scope.projectNoteIsHidden = function (projectNote) {
            // a project Note is hidden unless it contains at least one of the
            // note types that have been checked
            var noteTypeIDs = projectNote.noteTypes.map(function (noteType) {
              return noteType.noteTypeID.toString();
            });
            var result = projectDataService.selectedNoteTypes.filter(function (n) {
              return noteTypeIDs.indexOf(n) != -1;
            });

            return (result.length == 0);
          };

          //-- /Project Notes ------------------------------------------------



          $scope.allButtonStyle = "btn btn-xs btn-default";
          $scope.noneButtonStyle = "btn btn-xs btn-default";
          $scope.selectAll = function () {
            for (var key in $scope.listItems) {
              $scope.listItems[key].selected = true;
            }
            $scope.selectedValuesChanged();
          };

          $scope.selectNone = function () {
            for (var key in $scope.listItems) {
              $scope.listItems[key].selected = false;
            }
            $scope.selectedValuesChanged();
          };


          $scope.$watch('selectedValues.length', function () {
            setAllNoneButtonStyle();
          });

          $scope.$watch('listItems', function () {
            $scope.selectedValuesChanged();
            //$anchorScroll();

          });


          function setAllNoneButtonStyle() {
            $scope.allButtonStyle = "btn btn-xs btn-default";
            $scope.noneButtonStyle = "btn btn-xs btn-default";

            var listItemCount = Object.keys($scope.listItems).length;
            if ($scope.selectedValues.length == listItemCount) {
              $scope.allButtonStyle = "btn active btn-xs";
            }

            if ($scope.selectedValues.length == 0) {
              $scope.noneButtonStyle = "btn active btn-xs";
            }
          }

          $scope.selectedValuesChanged = function () {
            // return;
            var selectedCount = 0;
            // here we form up the list of active note types
            $scope.selectedValues = [];
            for (var key in $scope.listItems) {
              var item = $scope.listItems[key];
              if (item.selected) {
                $scope.selectedValues.push(item.value);
                selectedCount++;
              }
            }

            setAllNoneButtonStyle();
          };


          var setDialogProportionsForMobile = function () {
            const leftBorder = 10;
            const topBorder = 5;
            const dialogWidth = window.innerWidth - (3 * leftBorder);
            $(".modal-dialog").css({
              left: leftBorder,
              top: topBorder,
              width: dialogWidth
            });
            $(".modal-body ").css({
              paddingTop: 2,
              paddingBottom: 2,
            });
            $(".modal-footer ").css({
              marginTop: 0,
              marginBottom: 0,
              paddingTop: 2,
              paddingBottom: 2,
            });
          }
          // var dlgCreateMemberNote=null;
          $scope.openCreateMemberNoteDialog = function () {
            var dlgCreateMemberNote = dialogs.create('/app-ds3/memberNotes/createMemberNoteDialog.html',
              'createMemberNoteDialogCtrl',
              { projectID: projectDataService.project.projectID },
              {
                size: 'md',
                keyboard: true,
                backdrop: 'static',
                windowClass: 'my-class'
              }
            );

            // If we are on a mobile, extra action is needed
            // to posiion the dialog correctly. This need to be
            // done on the next turn   
            if (window.innerWidth < 600) {
           
              setTimeout(setDialogProportionsForMobile, 200);
              //   const leftBorder = 10;
              //   const topBorder = 5;
              //   const dialogWidth = window.innerWidth - (3 * leftBorder);
              //   $(".modal-dialog").css({
              //     left: leftBorder,
              //     top: topBorder,
              //     width: dialogWidth
              //   });
              //   $(".modal-body ").css({
              //     paddingTop: 2,
              //     paddingBottom: 2,
              //   });
              //   $(".modal-footer ").css({
              //     marginTop: 0,
              //     marginBottom: 0,
              //     paddingTop: 2,
              //     paddingBottom: 2,
              //   });
              //}, 200);
            };







            dlgCreateMemberNote.result.then(function (newMemberNote) {
              projectDataService.projectNotes.unshift(newMemberNote);

            }, function () {
              // Action upon failure
            });
          };

        }]
    };

  });


EICDataStream3ProjectDisplay.directive('noteItem', ['$compile', 'FEATURE_SWITCHES',
  function ($compile, FEATURE_SWITCHES) {

    var ANALYST_OPINION_ENABLED = FEATURE_SWITCHES.ANALYST_OPINION.Enabled;

    var standardNotesTemplate = "\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);'\
        style='vertical-align: top;white-space:nowrap;'>\
         {{::projectNote.noteDate | date:'MMM yyyy'}}\
    </td>\
    <td></td>\
    <td\
      ng-bind-html='projectNote.note | highlightKeywords'\
      style='overflow-wrap: break-word;'\
      ng-class='highlightClass(projectNote.created, projectNote.updated);' >\
    </td>\
    <td style='vertical-align: top;white-space:nowrap;'>\
      <ul class='list-unstyled ' ng-repeat='noteType in projectNote.noteTypes' >\
        <li ng-class='highlightClass(noteType.created, noteType.created);'>\
          {{::noteType.noteType}}\
        </li>\
      </ul>\
    </td><td>\
    </td>\
  ";

    // The member notes template varies the format by adding edit 
    // and delete controls
    var memberNotesTemplate = "\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);'\
        style='vertical-align: top;white-space:nowrap;font-style:italic;'>\
          {{::projectNote.noteDate | date:'MMM yyyy'}}\
    </td>\
    <td>\
      <i class='fa fa-pencil-square-o fa-lg'\
         style='color:blue;cursor:pointer;'\
         ng-click='openUpdateMemberNoteDialog(projectNote);'\
         tooltip='edit this note...'></i>\
    </td>\
    <td >\
      <div ng-class='highlightClass(projectNote.created, projectNote.updated);' \
        style='font-style:italic;'\
        ng-bind-html='projectNote.note | highlightKeywords'>\
      </div>\
      <div style='font-size:11px;'>\
        <span style='font-weight:bold;'>created by:</span> {{::projectNote.createdBy}} {{::projectNote.created | date:'dd MMM yyyy'}} &nbsp;&nbsp;&nbsp;\
        <span ng-if='projectNote.updated > projectNote.created'><span style='font-weight:bold;'>updated by:</span> {{::projectNote.updatedBy}} {{::projectNote.updated | date:'dd MMM yyyy'}}</span>\
      </div>\
    </td>\
    <td style='vertical-align: top;white-space:nowrap;'>\
      <ul class='list-unstyled ' ng-repeat='noteType in projectNote.noteTypes' >\
        <li ng-class='highlightClass(noteType.created, noteType.created);'\
            style='font-style:italic;'>\
            {{::noteType.noteType}}\
        </li>\
      </ul>\
    </td>\
    <td>\
      <i class='fa fa-times-circle fa-lg no-print'\
         style='color:red;margin-top:4px;cursor:pointer;'\
         ng-click='openDeleteMemberNoteDialog(projectNote);'\
         tooltip='delete this note...'\
         tooltip-placement='top'\
         tooltip-append-to-body='true'></i>\
    </td>\
  ";

    // The Analyst Opinion format varies the tmplay to add the words
    // Analyst opinion in bold above the note. There is also the possibilty
    // of adding the job title (such as 'Upstream Analyst' - but this practice
    // seems to have lapsed).
    // The most i9mportant point is that although 'Analyst Opinion' is a 
    // Note Type, it cannot stand alone. It MUST be coupled with a nother note
    // type ot the note will not be displayed
    var analystOpinionTemplate = "\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);'\
       style='vertical-align: top;white-space:nowrap;'>\
         {{::projectNote.noteDate | date:'MMM yyyy'}}\
    </td>\
    <td></td>\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);' >\
      <div style='font-weight:bold;'>Analyst's opinion ({{projectNote.editorJobTitle}})</div>\
      <div style='margin-left:20px'\
           ng-bind-html='projectNote.note | highlightKeywords'></div>\
    </td>\
    <td style='vertical-align: top;white-space:nowrap;'>\
      <ul class='list-unstyled ' ng-repeat='noteType in projectNote.noteTypes' >\
        <li ng-class='highlightClass(noteType.created, noteType.created);' ng-if='noteType.noteTypeID!=7'>\
          {{::noteType.noteType}}\
        </li>\
      </ul>\
    </td><td>\
    </td>\
  ";

    var getTemplate = function (contentType) {
      var template = '';
      switch (contentType) {
        case 6:        // memberNotes
          template = memberNotesTemplate;
          break;

        case 7:       // analystOpinion
          template = ANALYST_OPINION_ENABLED ? analystOpinionTemplate : standardNotesTemplate;
          break;

        default:        // standardNote
          template = standardNotesTemplate;
          break;
      }
      return template;
    };


    var getContentType = function (projectNote) {
      var contentType = 0;
      projectNote.noteTypes.forEach(
        function (nt) {
          var noteTypeID = nt.noteTypeID;
          if (noteTypeID == 6 || noteTypeID == 7) contentType = noteTypeID;
        });
      return contentType;
      // return projectNote.noteTypes[0].noteTypeID;
    };


    var linker = function (scope, element, attrs) {
      var contentType = getContentType(scope.projectNote);

      element.html(getTemplate(contentType)).show();

      $compile(element.contents())(scope);
    };

    var controller = ['$scope', 'dialogs', 'projectDataService', 'keywordsService',
      function ($scope, dialogs, projectDataService, keywordsService) {

        //-- Project Note Highlight ------------------------------------------------
        var dateDiff = function (startDate, endDate) {
          return ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
        };

        var projectCreatedWithinThreshold = function (dateCreated, dateUpdated, threshold) {
          return (dateDiff(dateCreated, new Date()) < threshold) && (dateUpdated - dateCreated < 5000);
        };

        var projectUpdatedWithinThreshold = function (dateUpdated, threshold) {
          return (dateDiff(dateUpdated, new Date()) < threshold);
        };

        $scope.highlightThreshold = 15;

        $scope.highlightClass = function (created, updated) {
          created = new Date(created);
          updated = new Date(updated);

          if (projectCreatedWithinThreshold(created, updated, $scope.highlightThreshold)) return "created";
          if (projectUpdatedWithinThreshold(updated, $scope.highlightThreshold)) return "updated";

          return "";

        };
        //-- /Project Note Highlight ------------------------------------------------


        //-- Member Notes Dialogs ------------------------------------------------
        $scope.openUpdateMemberNoteDialog = function (memberNote) {
          var dlgUpdateMemberNote = dialogs.create('/app-ds3/memberNotes/updateMemberNoteDialog.html',
            'updateMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );

          dlgUpdateMemberNote.result.then(function (memberNote) {
            // Find the old version of the note and replace it with the new one
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              var projectNote = projectDataService.projectNotes[i];
              var noteTypeID = projectNote.noteTypes[0].noteTypeID;
              if (memberNote.projectNoteID == projectNote.projectNoteID && memberNote.noteTypes[0].noteTypeID == noteTypeID) {
                //projectDataService.projectNotes.splice(i, 1);
                projectDataService.projectNotes.splice(i, 1, memberNote);
                break;
              }
            }
          }, function () {
            // Action upon failure
          });
        }

        $scope.openDeleteMemberNoteDialog = function (memberNote) {
          var dlgDeleteMemberNote = dialogs.create('/app-ds3/memberNotes/deleteMemberNoteDialog.html',
            'deleteMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );

          dlgDeleteMemberNote.result.then(function (deletedMemberNote) {
            // assuming the note was successfully delete, remove it from the project notes array
            // 1. get  the position of the membernote with the given MemberNoteID and the specified text
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              let projectNote = projectDataService.projectNotes[i];
              if (projectNote.projectNoteID == deletedMemberNote.projectNoteID && projectNote.note == deletedMemberNote.note) {
                projectDataService.projectNotes.splice(i, 1);
                break;
              }
            }


          }, function () {
            // Action upon failure
          });


        };
        //-- /Member Notes Dialogs ------------------------------------------------
      }];


    return {
      restrict: "AE",
      link: linker,
      scope: {
        projectNote: '=noteItem'
      },
      controller: controller
    };

  }]);

EICDataStream3ProjectDisplay.directive('mobileNoteItem', ['$compile', 'FEATURE_SWITCHES',
  function ($compile, FEATURE_SWITCHES) {

    var ANALYST_OPINION_ENABLED = FEATURE_SWITCHES.ANALYST_OPINION.Enabled;

    var standardNotesTemplate = `
    <div style='border-top: 1px solid #ddd;padding-bottom:10px'>
      <div style='display:flex' >
        <div ng-class='highlightClass(projectNote.created, projectNote.updated);'>
          {{::projectNote.noteDate | date:'MMM yyyy'}}
        </div>
        <div>
          <ul class='list-unstyled'
              style = 'margin-left:15px; margin-bottom:0'
              ng-repeat='noteType in projectNote.noteTypes'>
            <li ng-class='highlightClass(noteType.created, noteType.created);'>
              {{::noteType.noteType}}
            </li>
          </ul>
        </div>
      </div>
      <div
        style='font-weight:bold'
        ng-bind-html='projectNote.note | highlightKeywords'
        ng-class='highlightClass(projectNote.created, projectNote.updated);' >
      </div>
    </div>
  `;

    // The Analyst Opinion format varies the tmplay to add the words
    // Analyst opinion in bold above the note. There is also the possibilty
    // of adding the job title (such as 'Upstream Analyst' - but this practice
    // seems to have lapsed).
    // The most i9mportant point is that although 'Analyst Opinion' is a 
    // Note Type, it cannot stand alone. It MUST be coupled with a nother note
    // type ot the note will not be displayed
    var memberNotesTemplate = `
    <div style='border-top: 1px solid #ddd;padding-bottom:10px'>
      <div style='display:flex' ng-class='highlightClass(projectNote.created, projectNote.updated);' >
        <div
          style='font-weight:bold'>
          {{::projectNote.noteDate | date:'MMM yyyy'}}
        </div>
        <div>
          <ul class='list-unstyled'
              style = 'margin-left:15px; margin-bottom:0'
              ng-repeat='noteType in projectNote.noteTypes'>
            <li ng-class='highlightClass(noteType.created, noteType.created);'>
              {{::noteType.noteType}}
            </li>
          </ul>
        </div>
      </div>
      <div style='display:flex'>
        <div style='margin-right:10px'>
          <i class='fa fa-pencil-square-o fa-lg'
            style='color:blue;cursor:pointer;'
            ng-click='openUpdateMemberNoteDialog(projectNote);'
            tooltip='edit this note...'></i>
        </div>
        <div>
          <div ng-class='highlightClass(projectNote.created, projectNote.updated);' \
               style='font-style:italic;font-weight:bold;'
               ng-bind-html='projectNote.note | highlightKeywords'>
          </div>
          <div style='font-size:11px;'>
            <span style='font-weight:bold;'>created by:</span> {{::projectNote.createdBy}} {{::projectNote.created | date:'dd MMM yyyy'}} &nbsp;&nbsp;&nbsp;\
            <span ng-if='projectNote.updated > projectNote.created'><span style='font-weight:bold;'>updated by:</span> {{::projectNote.updatedBy}} {{::projectNote.updated | date:'dd MMM yyyy'}}</span>\
          </div>
        </div>
        <div>
          <i class='fa fa-times-circle fa-lg no-print'
            style='color:red;margin-top:4px;cursor:pointer;'
            ng-click='openDeleteMemberNoteDialog(projectNote);'
            tooltip='delete this note...'
            tooltip-placement='top'
            tooltip-append-to-body='true'></i>
        </div>
      </div>
    </div>
  `;

    var analystOpinionTemplate = `
    <div style='border-top: 1px solid #ddd;padding-bottom:10px'>
      <div style='display:flex' >
        <div ng-class='highlightClass(projectNote.created, projectNote.updated);'
          style='font-weight:bold;white-space:nowrap;margin-right:10px'>
          {{::projectNote.noteDate | date:'MMM yyyy'}}
        </div>
        <div ng-class='highlightClass(projectNote.created, projectNote.updated);' >
          <div style='font-weight:bold;'>Analyst's opinion <span ng-if='projectNote.editorJobTitle'>({{}})</span></div>
         </div>
        <div>
          <ul class='list-unstyled'
              style = 'margin-left:15px; margin-bottom:0'
              ng-repeat='noteType in projectNote.noteTypes'>
            <li ng-class='highlightClass(noteType.created, noteType.created);'
                ng-if= 'noteType.noteTypeID!=7' >
              {{::noteType.noteType}}
            </li>
          </ul>
        </div>
      </div>
      <div
        style='font-weight:bold'
        ng-bind-html='projectNote.note | highlightKeywords'
        ng-class='highlightClass(projectNote.created, projectNote.updated);' >
      </div>
    </div>
  `;


    var getTemplate = function (contentType) {
      var template = '';
      switch (contentType) {
        case 6:        // memberNotes
          template = memberNotesTemplate;
          break;

        case 7:       // analystOpinion
          template = ANALYST_OPINION_ENABLED ? analystOpinionTemplate : standardNotesTemplate;
          break;

        default:        // standardNote
          template = standardNotesTemplate;
          break;
      }
      return template;
    };


    var getContentType = function (projectNote) {
      var contentType = 0;
      projectNote.noteTypes.forEach(
        function (nt) {
          var noteTypeID = nt.noteTypeID;
          if (noteTypeID == 6 || noteTypeID == 7) contentType = noteTypeID;
        });
      return contentType;
      // return projectNote.noteTypes[0].noteTypeID;
    };


    var linker = function (scope, element, attrs) {
      var contentType = getContentType(scope.projectNote);

      element.html(getTemplate(contentType)).show();

      $compile(element.contents())(scope);
    };

    var controller = ['$scope', 'dialogs', 'projectDataService', 'keywordsService',
      function ($scope, dialogs, projectDataService, keywordsService) {

        //-- Project Note Highlight ------------------------------------------------
        var dateDiff = function (startDate, endDate) {
          return ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
        };

        var projectCreatedWithinThreshold = function (dateCreated, dateUpdated, threshold) {
          return (dateDiff(dateCreated, new Date()) < threshold) && (dateUpdated - dateCreated < 5000);
        };

        var projectUpdatedWithinThreshold = function (dateUpdated, threshold) {
          return (dateDiff(dateUpdated, new Date()) < threshold);
        };

        $scope.highlightThreshold = 15;

        $scope.highlightClass = function (created, updated) {
          created = new Date(created);
          updated = new Date(updated);

          if (projectCreatedWithinThreshold(created, updated, $scope.highlightThreshold)) return "created";
          if (projectUpdatedWithinThreshold(updated, $scope.highlightThreshold)) return "updated";

          return "";

        };
        //-- /Project Note Highlight ------------------------------------------------


        //-- Member Notes Dialogs ------------------------------------------------
        var setDialogProportionsForMobile = function () {
          const leftBorder = 10;
          const topBorder = 5;
          const dialogWidth = window.innerWidth - (3 * leftBorder);
          $(".modal-dialog").css({
            left: leftBorder,
            top: topBorder,
            width: dialogWidth
          });
          $(".modal-body ").css({
            paddingTop: 2,
            paddingBottom: 2,
          });
          $(".modal-footer ").css({
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 2,
            paddingBottom: 2,
          });
        }
        
        $scope.openUpdateMemberNoteDialog = function (memberNote) {
          var dlgUpdateMemberNote = dialogs.create('/app-ds3/memberNotes/updateMemberNoteDialog.html',
            'updateMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );
          dlgUpdateMemberNote.result.then(function (memberNote) {
            // Find the old version of the note and replace it with the new one
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              var projectNote = projectDataService.projectNotes[i];
              var noteTypeID = projectNote.noteTypes[0].noteTypeID;
              if (memberNote.projectNoteID == projectNote.projectNoteID && memberNote.noteTypes[0].noteTypeID == noteTypeID) {
                //projectDataService.projectNotes.splice(i, 1);
                projectDataService.projectNotes.splice(i, 1, memberNote);
                break;
              }
            }
          }, function () {
            // Action upon failure
          });

          setTimeout(setDialogProportionsForMobile, 200);

         // ensurePositionForMobile();

        }

        $scope.openDeleteMemberNoteDialog = function (memberNote) {
          var dlgDeleteMemberNote = dialogs.create('/app-ds3/memberNotes/deleteMemberNoteDialog.html',
            'deleteMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );

          setTimeout(setDialogProportionsForMobile, 200);

          //ensurePositionForMobile();

          dlgDeleteMemberNote.result.then(function (deletedMemberNote) {
            // assuming the note was successfully delete, remove it from the project notes array
            // 1. get  the position of the membernote with the given MemberNoteID and the specified text
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              projectNote = projectDataService.projectNotes[i];
              if (projectNote.projectNoteID == deletedMemberNote.projectNoteID && projectNote.note == deletedMemberNote.note) {
                projectDataService.projectNotes.splice(i, 1);
                break;
              }
            }


          }, function () {
            // Action upon failure
          });
        };
        //-- /Member Notes Dialogs ------------------------------------------------

        // var ensurePositionForMobile = function () {
        //   // If we are on a mobile, extra action is needed
        //   // to posiion the dialog correctly. This need to be
        //   // done on the next turn   
        //   if (window.innerWidth < 600) {
        //     setTimeout(function () {
        //       $(".modal-dialog").css({ left: 20 });
        //     }, 200);
        //   };
        // }

      }];


    return {
      restrict: "AE",
      link: linker,
      scope: {
        projectNote: '=mobileNoteItem'
      },
      controller: controller
    };

  }]);

EICDataStream3ProjectDisplay.factory('projectDataService',
  [
    '$rootScope', '$timeout', 'searchService', 'savedSearches',
    'projects', 'project', 'projectTypes', 'projectNotes', 'projectOperatingCompanies', 'projectLocations',
    'projectRelatedProjects', 'projectLinks', 'projectContracts',
    function ($rootScope,
      $timeout,
      searchService,
      savedSearches,
      projects,
      project,
      projectTypes,
      projectNotes,
      projectOperatingCompanies,
      projectLocations,
      projectRelatedProjects,
      projectLinks,
      projectContracts) {

      var projectDataService = {};

      projectDataService.searchURL = "";

      projectDataService.projectID = 0;

      projectDataService.project = null;
      projectDataService.isProject = false;

      projectDataService.projectNotes = [];

      // handled by eicNoteTypeSelector directive
      projectDataService.selectedNoteTypes = [];
      projectDataService.isCollapsed = true;


      projectDataService.busy = false;
      projectDataService.loading = false;


      projectDataService.search = function (searchGuid) {
        if (!projectDataService.isProject) {

          projectDataService.cancelLoading = true;

          savedSearches.get({ guid: searchGuid },
            startSearch,
            function () {
              showDataErrorMessage("There was an error and the search failed to start");
            }
          );
        }
      };


      var showDataErrorMessage = function (message) {
        projectDataService.dataErrorMessage = message;
        $timeout(function () {
          projectDataService.dataErrorMessage = "";
        },
          5000);
      };


      projectDataService.getProject = function (projectID) {
        return project.get({ id: projectID },
          function (item) {
            projectDataService.project = item;

            projectDataService.project.electricalCablesSubCollection = function (subject) {
              return projectDataService.project.electricalCables.filter(function (item) {
                return (item.electricalCableType.substring(0, 4) == subject.substring(0, 4));
              });
              //            switch(subject) {
              //              case "Transmission Lines":
              //                return item.electricalCables.map(function (item) {
              //                  if (item.electricalCableType == subject) return item;
              //                });
              //              case "Power Export Cables":
              //                return item.electricalCables.map(function (item) {
              //                  if (item.electricalCableType == subject) return item;
              //                });
              //              case "Inter-array Cables":
              //                return projectDataService.project.electricalCables.map(function (item) {
              //                  if (item.electricalCableType == subject) return item;
              //                });
              //            }

            }

            projectDataService.getOperatingCompanies(projectID);
            projectDataService.getProjectLocations(projectID);
            projectDataService.getRelatedProjects(projectID);
            projectDataService.getProjectLinks(projectID);
            projectDataService.getProjectContracts(projectID);
            projectDataService.getFirstPageOfProjectNotes();


            // Accumulate reserves and production of field hydrocarbons where the type and subtype are the same
            // $scope.fieldHydrocarbons = {}

            if (projectDataService.project.fieldHydrocarbons) {
              var fieldHydrocarbons = {};

              for (var i = 0; i < projectDataService.project.fieldHydrocarbons.length; i++) {
                var fieldHydrocarbon = projectDataService.project.fieldHydrocarbons[i];

                var type = fieldHydrocarbon.type ? fieldHydrocarbon.type : "";
                var subType = fieldHydrocarbon.subType ? fieldHydrocarbon.subType : "";
                var productionUnit = fieldHydrocarbon.productionUnit;
                var reservesUnit = fieldHydrocarbon.reservesUnit;
                //var type = fieldHydrocarbon.hydrocarbonType ? fieldHydrocarbon.hydrocarbonType.hydrocarbonType1: "";
                //var subType = fieldHydrocarbon.hydrocarbonSubType ? fieldHydrocarbon.hydrocarbonSubType.hydrocarbonSubType1 : "";
                //var productionUnit = fieldHydrocarbon.hydrocarbonType.hydrocarbonGroup.productionUnit;
                //var reservesUnit = fieldHydrocarbon.hydrocarbonType.hydrocarbonGroup.reservesUnit;


                var key = type + subType;
                if (!fieldHydrocarbons[key]) {
                  // create an entry
                  fieldHydrocarbons[key] = {
                    type: type,
                    subType: subType,
                    reserves: 0,
                    production: 0,
                    life: 0,
                    productionUnit: productionUnit,
                    reservesUnit: reservesUnit
                  };
                }

                // accumulate
                fieldHydrocarbons[key].reserves += projectDataService.project.fieldHydrocarbons[i].reserves;
                fieldHydrocarbons[key].production += projectDataService.project.fieldHydrocarbons[i].production;
                if (projectDataService.project.fieldHydrocarbons[i].life > fieldHydrocarbons[key].life)
                  fieldHydrocarbons[key].life = projectDataService.project.fieldHydrocarbons[i].life;
              }

              projectDataService.project.fieldHydrocarbons = fieldHydrocarbons;
            }

            projectDataService.fidDataExists = (projectDataService.project.fid.expected ||
              projectDataService.project.fid.received ||
              projectDataService.project.fid.debtEquityRatio);

          });
      };


      // Project Operators ----------------------------------------------------------
      projectDataService.operatingCompanies = [];

      projectDataService.getOperatingCompanies = function (projectID) {
        projectDataService.operatingCompanies = [];
        projectOperatingCompanies.query({ projectID: projectID },
          function (items) {
            projectDataService.operatingCompanies = items;
          });

      };
      // ----------------------------------------------------------------------------

      // Related Projects -----------------------------------------------------------
      projectDataService.relatedProjects = [];

      projectDataService.getRelatedProjects = function (projectID) {
        projectDataService.relatedProjects = [];
        projectRelatedProjects.query({ projectID: projectID },
          function (items) {
            projectDataService.relatedProjects = items;
          });

      };
      // ----------------------------------------------------------------------------

      // Links ----------------------------------------------------------------------
      projectDataService.links = [];

      projectDataService.getProjectLinks = function (projectID) {
        projectDataService.links = [];
        projectLinks.query({ projectID: projectID },
          function (items) {
            projectDataService.links = items;
          });

      };
      // ----------------------------------------------------------------------------

      // Project Locations ----------------------------------------------------------
      projectDataService.projectLocations = [];

      projectDataService.getProjectLocations = function (projectID) {
        projectDataService.projectLocations = [];
        projectLocations.query({ projectID: projectID },
          function (items) {
            projectDataService.projectLocations = items;
          });

      };
      // ----------------------------------------------------------------------------

      //// This should no longer be needed now that  the conversion to  single 
      //// project type has been completed
      //// removed 8 Aug 2015
      //// Project Types ----------------------------------------------------------
      //projectDataService.projectTypes = [];

      //projectDataService.getProjectTypes = function (projectID) {
      //  projectTypes.query({ projectID: projectID }, function (items) {
      //    projectDataService.projectTypes = items;
      //  });

      //};
      //// ----------------------------------------------------------------------------

      // Contracting Information ----------------------------------------------------------
      projectDataService.projectContracts = [];

      projectDataService.getProjectContracts = function (projectID) {
        // to  prevent the posibillity of old data being left ibn view,
        // clear the list  of contracts before starting the search
        // (bg 28 Aug 2023)
        projectDataService.projectContracts = [];
        projectContracts.query({ projectID: projectID },
          function (items) {
            projectDataService.projectContracts = items;
          });

      };


      // ----------------------------------------------------------------------------


      //-- New Project Notes Implementation    -------------------------------------
      projectDataService.getFirstPageOfProjectNotes = function () {
        // to  prevent the posibillity of old data being left ibn view,
        // clear the list  of project notes before starting the search
        // (bg 28 Aug 2023)
        projectDataService.projectNotes = [];
        projectDataService.projectNotes = projectNotes.query(
          { projectID: projectDataService.project.projectID, limit: projectDataService.projectNoteLimit, offset: 0 },
          function (items) {
            var itemCount = items.length;
            projectDataService.no_moreProjectNotes = itemCount < projectDataService.projectNoteLimit;
            projectDataService.projectNotes = items;
          }
        );
      };

      projectDataService.getAllProjectNotes = function () {
        // guard condition : if the first page contained all the notes,
        // no need to refetch
        // if (projectDataService.no_moreProjectNotes) return;

        if (!projectDataService.project) return;

        projectDataService.projectNotes = projectNotes.query({ projectID: projectDataService.project.projectID },
          function (items) {
            projectDataService.no_moreProjectNotes = true;
            projectDataService.projectNotes = items;
          }
        );

      };

      projectDataService.projectNoteLimit = 20;
      projectDataService.no_moreProjectNotes = true;

      projectDataService.noteTypes =
      {
        contractActivity: { text: "Contract Activity", value: "1", selected: true },
        developmentNews: { text: "Development", value: "2", selected: true },
        planningProcess: { text: "Planning", value: "3", selected: true },
        financialNews: { text: "Financial", value: "4", selected: true },
        generalNews: { text: "General", value: "5", selected: true },
        memberNotes: { text: "Member Notes", value: "6", selected: true }
      };
      //-- /New Project Notes Implementation    ------------------------------------


      return projectDataService;
    }
  ]);


EICDataStream3ProjectDisplay
  .directive('stackableTable',
    [
      '$window', function ($window) {
        return {
          link: function (scope, elem, attrs) {
            // setup
            const thCount = elem.find("th").length;
            const rowGrow = 100 / thCount + '%';
            //console.log(rowGrow);
            elem.find("th, td").css('flex-basis', rowGrow);

            elem.find("th")
              .each(function (i) {
                $('td:nth-child(' + (i + 1) + ')')
                  .prepend('<span class="stacked-table-thead">' + $(this).text() + ':</span> ');
                $('.stacked-table-thead').hide();

              });




            function flexTable() {
              if ($(window).width() < 768) {
                // window is less than 768px
                elem.addClass('stackable-table');

                elem.find(".stacked-table-thead").show();
                elem.find('thead').hide();

                elem.find('td.alignRight, th.alignRight')
                  .removeClass('alignRight')
                  .addClass('wideAlignRight');


              } else {
                // window is greater than 768px   
                elem.removeClass('stackable-table');

                elem.find(".stacked-table-thead").hide();
                elem.find('thead').show();

                elem.find('td.wideAlignRight, th.wideAlignRight')
                  .removeClass('wideAlignRight');
              }

            }

            flexTable();

            window.onresize = function (event) {
              flexTable();
            };


            //angular.element(elem)
            //  .bind('resize',
            //    function() {
            //      //do something on resize
            //      flexTable();
            //    });



          }
        }
      }
    ]);
